import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { Instagram, Facebook, Music2, CreditCard, Apple } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#1A1F2C] text-white mt-24">
      <div className="px-4 sm:px-8 lg:px-16 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12">
        <div className="sm:col-span-2">
          <span className="font-serif-display text-2xl">Mimi Silver</span>
          <p className="text-sm text-white/60 mt-3 max-w-xs leading-relaxed">{t("footer_tagline")}</p>
          <div className="mt-6">
            <h4 className="text-xs tracking-luxe uppercase text-[#C5A880] mb-3">{t("social_follow")}</h4>
            <div className="flex items-center gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" aria-label="Instagram" className="text-white/70 hover:text-[#C5A880] transition-colors">
                <Instagram className="w-5 h-5" strokeWidth={1.4} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" aria-label="Facebook" className="text-white/70 hover:text-[#C5A880] transition-colors">
                <Facebook className="w-5 h-5" strokeWidth={1.4} />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" data-testid="social-tiktok" aria-label="TikTok" className="text-white/70 hover:text-[#C5A880] transition-colors">
                <Music2 className="w-5 h-5" strokeWidth={1.4} />
              </a>
            </div>
          </div>
        </div>
        <div>
          <h4 className="text-xs tracking-luxe uppercase text-[#C5A880] mb-4">{t("footer_shop")}</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/shop/rings" className="hover:text-white transition-colors">{t("nav_rings")}</Link></li>
            <li><Link to="/shop/necklaces" className="hover:text-white transition-colors">{t("nav_necklaces")}</Link></li>
            <li><Link to="/shop/earrings" className="hover:text-white transition-colors">{t("nav_earrings")}</Link></li>
            <li><Link to="/shop/bracelets" className="hover:text-white transition-colors">{t("nav_bracelets")}</Link></li>
            <li><Link to="/gifts" className="hover:text-white transition-colors">{t("nav_gifts")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-luxe uppercase text-[#C5A880] mb-4">{t("footer_help")}</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/returns" data-testid="footer-returns-link" className="hover:text-white transition-colors">{t("footer_returns")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-luxe uppercase text-[#C5A880] mb-4">{t("footer_contact")}</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li>Bahnhofstrasse 1, Zürich</li>
            <li>+41 44 000 00 00</li>
            <li>hello@mimisilver.ch</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="text-xs text-white/40">© {new Date().getFullYear()} Mimi Silver. {t("rights")}</span>
        <div className="flex items-center gap-3 text-white/50">
          <span className="text-[10px] tracking-luxe uppercase">{t("pay_with")}</span>
          <CreditCard className="w-5 h-5" strokeWidth={1.4} />
          <Apple className="w-5 h-5" strokeWidth={1.4} />
          <span className="text-xs font-semibold tracking-wide">TWINT</span>
        </div>
      </div>
    </footer>
  );
};
